export const toNum = (str: string | undefined) =>
  str ? parseFloat(str) : undefined;
